import { Button } from '@cian/ui-kit';

import * as React from 'react';

interface IContinueButton {
  isMobile?: boolean;
  onClick(event: React.SyntheticEvent<HTMLButtonElement>): void;
}

export const ContinueButton: React.FC<IContinueButton> = ({ isMobile, onClick }) => {
  const buttonSize = isMobile ? 'M' : 'XS';
  const buttonTheme = isMobile ? 'fill_secondary' : 'fill_primary';

  return (
    <Button size={buttonSize} theme={buttonTheme} type="button" onClick={onClick} fullWidth={isMobile}>
      Продолжить
    </Button>
  );
};

ContinueButton.displayName = 'ContinueButton';
